import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Compass, Sparkles, Crown } from "lucide-react";

const TIER_BADGE = {
    elite: { cls: "bg-[#FFE55C]", Icon: Crown, label: "Elite" },
    pod: { cls: "bg-[#FFB8D1]", Icon: Sparkles, label: "Pod" },
};

export default function Discover() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/discover").then((r) => setUsers(r.data)).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
    }, []);

    return (
        <main className="max-w-3xl mx-auto px-4 py-8">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-11 h-11 rounded-lg brut-static bg-[#B8E1FF] flex items-center justify-center">
                    <Compass className="w-5 h-5" />
                </div>
                <div>
                    <h1 className="display text-3xl sm:text-4xl font-black">Discover posters</h1>
                    <p className="text-sm text-[#4A4A4A] font-medium">Fresh faces to follow, ranked by community reach.</p>
                </div>
            </div>

            {loading ? (
                <div className="font-bold text-[#4A4A4A]">Loading…</div>
            ) : users.length === 0 ? (
                <div className="border-2 border-dashed border-[#0A0A0A] rounded-xl p-8 text-center bg-white/60" data-testid="discover-empty">
                    <div className="font-black">Nobody around yet.</div>
                    <div className="text-sm text-[#4A4A4A] mt-1 font-medium">Be the first — invite the pod.</div>
                </div>
            ) : (
                <ul className="grid sm:grid-cols-2 gap-3" data-testid="discover-list">
                    {users.map((u) => {
                        const tier = TIER_BADGE[u.tier];
                        return (
                            <li key={u.username}>
                                <Link
                                    to={`/u/${u.username}`}
                                    className="flex items-center gap-3 brut-static bg-white rounded-xl p-4 hover:bg-[#FFFDF7]"
                                    data-testid={`discover-user-${u.username}`}
                                >
                                    <div className="w-12 h-12 rounded-full bg-[#FFB8D1] border-2 border-[#0A0A0A] flex items-center justify-center font-black text-lg shrink-0">
                                        {u.username[0].toUpperCase()}
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-1.5">
                                            <div className="font-black truncate">@{u.username}</div>
                                            {tier && (
                                                <span className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full border border-[#0A0A0A] text-[9px] font-black uppercase ${tier.cls}`}>
                                                    <tier.Icon className="w-2.5 h-2.5" /> {tier.label}
                                                </span>
                                            )}
                                        </div>
                                        {u.bio && <div className="text-xs text-[#4A4A4A] truncate">{u.bio}</div>}
                                        <div className="text-[11px] text-[#4A4A4A] font-medium mt-0.5">
                                            {u.followers_count} follower{u.followers_count === 1 ? "" : "s"} · {u.posts_count} post{u.posts_count === 1 ? "" : "s"}
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            )}
        </main>
    );
}
